import React from 'react';
import Container from 'container';
import SubHeadline from 'shared/sub-headline';
import Headline from 'headline';
import RichSnippet from 'seo-schema';
import Dropdown from './dropdown';
import s from './dropdowns.module.scss';

export default function Dropdowns({
  small_title,
  title,
  dropdowns,
  primaryQuestion,
  grey,
  no_rich_snippet,
  white,
  ...props
}) {
  const greyBackgroundClass = grey ? s.greybg : '';
  const whiteBackgroundClass = white ? s.white : '';
  return (
    <>
      {!no_rich_snippet && <RichSnippet faqs={dropdowns} />}
      <Container
        className={`${s.root} ${greyBackgroundClass} ${whiteBackgroundClass} dropdowns`}
        data-placement={props.placement}
      >
        <SubHeadline
          className={s.smallTitle}
          html={small_title}
          center
          noLine
        />
        <Headline underline h3 center className={s.title} html={title} />
        <ul>
          {dropdowns &&
            dropdowns.map((el, i) => {
              return (
                <Dropdown
                  white={white}
                  key={`dropdowns-${i}-${el.question.slice(0, 10)}`}
                  {...{ ...el, primaryQuestion }}
                />
              );
            })}
        </ul>
        {props.children || ''}
      </Container>
    </>
  );
}
